import React from 'react';
//import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';

import classes from './App.module.scss';
import Navbar from './Components/Navbar/Navbar';
import LandingPage from './Components/Landingpage/Landingpage';
import About from './Components/About/About';
import Projects from './Components/Projects/Projects';
import Contacts from './Components/Contacts/Contacts'

const App = () => {
  const darkMode = useSelector(state => state.darkMode)

    let mode = null;

    if(darkMode){
        mode = classes.AppDark
    } else {
        mode = classes.AppLight
    }

  return (
    <div className={mode} data-mode={darkMode}>
        <Navbar />
        <LandingPage />
        <About />
        <Projects />
        <Contacts />
        {/* <Switch>
          <Route exact path="/#" component={LandingPage} />
          <Route exact path='/#about' component={About} />
          <Route exact path="/#projects" component={Projects} />
        </Switch> */}
          
       
    </div>
  );
}

export default App;
